import {Component, Inject, OnInit} from '@angular/core';

import {Observable} from 'rxjs/Observable';
import {AuthService, LieferzeitService} from '../infrastructure/services';
import {HttpClient} from '@angular/common/http';
import {CookieService} from 'angular2-cookie/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  isLoggedIn$: Observable<boolean>;
  private lblSprache: string;
  private lieferzeit;
  private showdebug: boolean;
  private testblub: string;
  private _cookieSercvce: CookieService;
  private selectedLanguage: string;
  Selectedlanguage(language) {
    this.selectedLanguage = language;
    this._cookieService.put('locale', language, {'expires': new Date(9999, 12, 31).toUTCString()});
    this.http.put<string>(this.baseUrl + '/api/sprache', language).subscribe();
    this.http.get(this.baseUrl + '/api/lieferzeit', { responseType: 'text' }).subscribe(lieferzeit => this.lieferzeit = lieferzeit);
    this.http.get(this.baseUrl + '/api/sprache/label', { responseType: 'text' }).subscribe(lblSprache => this.lblSprache = lblSprache);
  }
  constructor(@Inject('BASE_URL') private baseUrl: string, private _cookieService: CookieService,
  private lieferzeitService: LieferzeitService, private authService: AuthService, @Inject('$scope') private $scope: any,
  private http: HttpClient ) {
    this.selectedLanguage = _cookieService.get('locale');
    this.$scope = $scope;
  }
  DebugChange(): void {
    this.showdebug = !this.showdebug;
  }
  ngOnInit(): void {
    this.isLoggedIn$ = this.authService.isAuth;
    const vm = this;
    vm.showdebug = false;
    this.$scope.$on('tokenReceived', () => {
      vm.http.get(vm.baseUrl + '/api/lieferzeit', { responseType: 'text' }).subscribe(lieferzeit => vm.lieferzeit = lieferzeit);
      vm.http.get(vm.baseUrl + '/api/sprache/label', { responseType: 'text' }).subscribe(lblSprache => vm.lblSprache = lblSprache);
      this.http.get(this.baseUrl + '/api/user/sessionString', { responseType: 'text'})
        .subscribe(conectionId => this.testblub = conectionId);
    });

    this.isLoggedIn$.subscribe(isAuth => {
        if (isAuth === true) {
          this.lieferzeitService.getLieferzeit().subscribe(lieferzeit => this.lieferzeit = lieferzeit);
          vm.http.get(vm.baseUrl + '/api/sprache/label', { responseType: 'text' }).subscribe(lblSprache => vm.lblSprache = lblSprache);
          this.http.get(this.baseUrl + '/api/user/sessionString', { responseType: 'text'})
            .subscribe(conectionId => this.testblub = conectionId);
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/app/footer/footer.component.ts